import styled from "styled-components";

export const NewStyled = styled.div`
  .new_container {
    cursor: pointer;
    .n_left_col {
      margin-bottom: 15px;
    }
    .n_right_col {
      overflow: hidden;
      .n_header {
        margin-bottom: 3px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) =>
          `${theme.FONT.STYLE.GT_AMERICA_STANDARD_BOLD},${theme.FONT.STYLE.PROMPT_SEMIBOLD}`};
      }
      .n_description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${({ theme }) => theme.COLORS.BLACK_1} !important;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12} !important;
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT} !important;
      }
    }
  }

  .theme_standard {
  }
`;
